export default [
  {
    title: 'Benvinguda',
    element: '.none',
    text: 'Benvingut a {{wlName}}, la teva plataforma mèdica d\'intercanvi d\'imatges. En aquesta visita us ajudarem a començar.'
  },
  {
    title: 'Resultats mèdics',
    element: '.icons-layout',
    text: 'Aquí podrà veure totes les carpetes, documents i proves mèdiques que li hagin compartit.'
  },
  {
    title: 'Encara no hi ha resultats',
    element: '.empty-folder',
    text: 'Sembla que encara no han pujat els seus resultats. Aquest procés pot trigar diversos dies.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Veure els arxius',
    element: '.icon-wrapper-file',
    text: 'Pot fer <strong>clic</strong> per entrar en carpetes o obrir arxius.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/ca-ES/guestTour.js